export const COURSE_LIST = 'learning/COURSE_LIST';
export const CURRENT_COURSE = 'learning/CURRENT_COURSE';
export const COURSE_DATA = 'learning/COURSE_DATA';
export const FETCH_COURSE_LIST = 'learning/FETCH_COURSE_LIST';
export const FETCH_COURSE_DATA = 'learning/FETCH_COURSE_DATA';
export const SUBMIT_COURSE_RESULT = 'learning/SUBMIT_COURSE_RESULT';
export const CANCEL_LAST_TIME_LEARNED = 'learning/CANCEL_LAST_TIME_LEARNED';
export const FIRST_LOGIN = 'learning/FIRST_LOGIN';
